import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Autocomplete,
	Box,
	Button,
	Checkbox,
	Chip,
	Container,
	Divider,
	FormControlLabel,
	FormGroup,
	IconButton,
	InputAdornment,
	Menu,
	MenuItem,
	TextField,
	Typography,
} from "@mui/material";
import React, { useState } from "react";
import MainDrawer from "../MainDrawer";
import { useAuth } from "../../helpers/AuthProvider";
import { useNavigate } from "react-router-dom";
import { ExpandMore } from "@mui/icons-material";
import queryGraphql from "../../helpers/ApiInterface";
import ApplicationsTable from "./ApplicationsTable";
import MiniBot from "../MiniBot";
interface SearchOptions {
	chipLabel: string;
	dropdownLabel: string;
	category: string;
	groupBy: string;
}
let searchOptions: SearchOptions[] = [];
const ApplicationsPage: React.FC = () => {
	const [applications, setApplications] = useState([]);
	const { user } = useAuth();
	const navigate = useNavigate();
	const [searchQuery, setSearchQuery] = useState<SearchOptions[]>([]);
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	// const isClusterOwnerOrAdmin =
	// 	user.roles.some((e: string) => ["cluster_owner", "idp_admin"].includes(e)) || false;
	const [updates, setUpdates] =  useState<any>([]);
	const [addApplicationMenuAnchorEl, setAddApplicationMenuAnchorEl] = useState<null | HTMLElement>(null); // State for Add Application Menu
	const isAddApplicationMenuOpen = Boolean(addApplicationMenuAnchorEl);
	
		// --- Handlers for the "Add Cluster" Menu ---
	  const handleAddApplicationMenuClick = (event: React.MouseEvent<HTMLButtonElement>) => {
			setAddApplicationMenuAnchorEl(event.currentTarget);
		};
	
		const handleAddApplicationMenuClose = () => {
			setAddApplicationMenuAnchorEl(null);
		};
	
		const handleAddApplicationMenuItemClick = (path: string) => {
			navigate(path); // Make sure to use your correct routes
			handleAddApplicationMenuClose(); // Close the menu after clicking an item
		};
	const addApplicationButtonId = 'add-application-action-button';
    const addApplicationMenuId = 'add-application-action-menu';
	React.useEffect(() =>{
		const fetchData = async () => {
			try {
				const data = await queryGraphql(`
                        query Query {
						resourceStatuses {
							id
							currentStatus
							resourceId
						}
						}
					`);
				if(data.resourceStatuses){
					setUpdates(data.resourceStatuses);
					
				}
				}
				catch(e){
			console.log(e);
				}
	}
	fetchData();
	},[]);	

	const isApplicationOwner =
		user.roles?.some((e: string) => ["application_owner","viewer"].includes(e)) || false;
	const [columnFilters, setColumnFilters] = useState<Record<string, boolean>>({
		applicationName: true,
		environment: true,
		clusterName: true,
		services: true,
		applicationOwner: true,
		createdAt: true,
	});
	const filteredApplications =
		searchQuery.length == 0
			? applications
			: applications.filter(
					(application: any) =>
						(searchQuery.filter((e) => e.category == "applicationName").length > 0
							? searchQuery
									.filter((e) => e.category == "applicationName")
									.map((e) => e.dropdownLabel.toLowerCase())
									.includes(application.applicationName.toLowerCase())
							: true) &&
						(searchQuery.filter((e) => e.category == "applicationOwner").length > 0
							? searchQuery
									.filter((e) => e.category == "applicationOwner")
									.map((e) => e.dropdownLabel.toLowerCase())
									.includes(application.applicationOwner.toLowerCase())
							: true) &&
						(searchQuery.filter((e) => e.category == "environment").length > 0
							? searchQuery
									.filter((e) => e.category == "environment")
									.map((e) => e.dropdownLabel.toLowerCase())
									.includes(application.environment.toLowerCase())
							: true) &&
						(searchQuery.filter((e) => e.category == "clusterName").length > 0
							? searchQuery
									.filter((e) => e.category == "clusterName")
									.map((e) => e.dropdownLabel.toLowerCase())
									.includes(application.clusterName.toLowerCase())
							: true)
			  );

	const filteredActiveApplications = filteredApplications.filter(
		(application: any) => application.status === "active"
	);
	const filteredPendingApplications = filteredApplications.filter(
		(application: any) => application.status === "pending"
	);
	const filteredRejectedApplications = filteredApplications.filter(
		(application: any) => application.status === "rejected"
	);

	React.useEffect(() => {
		const fetchData = async () => {
			try {
				const data = await queryGraphql(`
                        query{
                        applications {
						id,
                        applicationName,
						environment,
						status,
						createdAt,
						cluster{
						id,
						clusterName,
						},
                        applicationOwner{
						id,
						email,
						name,
						googleProfilePicture
						},
						services{
						id,
						serviceName,
						}
                        }
                        }
					`);

				let applicationsArr = data.applications.map((e: any) => {
					let rand = Math.random() * 8;

					return {
						...e,
						services: e.services,
						applicationOwnerAvatar: e?.applicationOwner?.googleProfilePicture,
						applicationOwner: e?.applicationOwner?.name,
						createdAt: new Date(Number(e.createdAt)).toISOString(),
						clusterName: e?.cluster?.clusterName,
					};
				});
				setApplications(applicationsArr);
				searchOptions = applicationsArr
					.map((e: any) => {
						return [
							{
								category: "applicationName",
								groupBy: "APPLICATION NAME",
								chipLabel: `Application Name: ${e.applicationName}`,
								dropdownLabel: e.applicationName,
							},
							{
								category: "environment",
								groupBy: "ENVIRONMENT",
								chipLabel: `Environment: ${e.environment}`,
								dropdownLabel: e.environment,
							},
							{
								category: "clusterName",
								groupBy: "CLUSTER NAME",
								chipLabel: `Cluster Name: ${e.clusterName}`,
								dropdownLabel: e.clusterName,
							},
							{
								category: "applicationOwner",
								groupBy: "OWNER",
								chipLabel: `Owner: ${e.applicationOwner}`,
								dropdownLabel: e.applicationOwner,
							},
						];
					})
					.flat();

				searchOptions = searchOptions.filter(
					(obj, index, self) =>
						index ===
						self.findIndex(
							(t) => t.category === obj.category && t.dropdownLabel === obj.dropdownLabel
						)
				);
				searchOptions.sort((a, b) => {
					if (a.groupBy > b.groupBy) return 1;
					if (a.groupBy < b.groupBy) return -1;
					if (a.dropdownLabel > b.dropdownLabel) return 1;
					if (a.dropdownLabel < b.dropdownLabel) return -1;
					return 0;
				});
			} catch (error) {
				console.log(error);
			}
		};

		fetchData();
	}, []);
	const handleFilterClick = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleFilterClose = () => {
		setAnchorEl(null);
	};
	const toggleColumnFilter = (column: string) => {
		setColumnFilters((prevFilters) => ({
			...prevFilters,
			[column]: !prevFilters[column],
		}));
	};
	return (
		<Box sx={{ display: "flex" }}>
			<MiniBot/>
			<MainDrawer index={"applications"} />
			<Box
				component="main"
				// display="inline-block"
				sx={{
					flex: 1,
					bgcolor: "#fafafa",

					minHeight: window.innerHeight,
				}}
			>
				<Container maxWidth={false} disableGutters>
					<Box bgcolor="#FFFFFF" p={2} mb="18px">
						<Box
							sx={{
								display: "flex",
								justifyContent: "space-between",
								alignItems: "center",
								marginBottom: 1,
								mx: 2,
							}}
						>
							<Typography fontSize="22px" gutterBottom fontFamily="Gilroy-Bold">
								Applications
							</Typography>

							{/* <Button
								variant="contained"
								color="primary"
								disabled={!isApplicationOwner}
								sx={{
									backgroundColor: "black",
									color: "white",
									padding: "8px 24px",
									fontSize: "0.875rem",
									textTransform: "none",
								}}
								onClick={() => navigate("/applications/add")}
							>
								<Typography fontSize="14px" fontFamily="Gilroy-Bold">
									Add New Application
								</Typography>
							</Button> */}
							<Box sx={{display:'flex', justifyContent:'center'}}>
							<Button
                              id={addApplicationButtonId} // Add ID
                                aria-controls={isAddApplicationMenuOpen ? addApplicationMenuId : undefined} // Add ARIA controls
                                aria-haspopup="true" // Add ARIA haspopup
                                aria-expanded={isAddApplicationMenuOpen ? 'true' : undefined} // Add ARIA expanded state
                                variant="contained"
                                // color="primary" // Not needed due to explicit background color
                                disabled={!isApplicationOwner}
                                sx={{
                                    backgroundColor: "black", // Keep your styles
                                    color: "white",
                                    padding: "8px 24px",
                                    fontSize: "0.875rem",
                                    textTransform: "none",
                                    '&:hover': { // Optional: Adjust hover if needed
                                        backgroundColor: '#333',
                                    }
                                }}
                                onClick={handleAddApplicationMenuClick} // CHANGE onClick handler
                            >
                                <Typography fontSize="14px" fontFamily="Gilroy-Bold">
                                    {/* Optional: Change button text */}
                                    Add New Application
                                </Typography>
                            </Button>
                         
                            <Menu
                                id={addApplicationMenuId} // Add ID
                                MenuListProps={{
                                    'aria-labelledby': addApplicationButtonId, // Link to button ID
                                }}
                                anchorEl={addApplicationMenuAnchorEl} // Use specific anchor state
                                open={isAddApplicationMenuOpen} // Use specific open state
                                onClose={handleAddApplicationMenuClose} // Use specific close handler
                                // Optional positioning adjustments
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                            >
                                <MenuItem onClick={() => handleAddApplicationMenuItemClick('/applications/add/nonk8s')}> {/* ADJUST PATH */}
                                    Add Non K8s Application
                                </MenuItem>
                                <MenuItem onClick={() => handleAddApplicationMenuItemClick('/applications/add')}> {/* ADJUST PATH */}
                                    Add K8s Application
                                </MenuItem>
                            </Menu>

							<IconButton
									  aria-label="Help" 
									  onClick={()=> window.open(`${process.env.REACT_APP_HOST_DOMAIN}/docs` , "_blank")}
									  sx={{
										padding: 0, 
										border: 'none',  
										ml:2,
										'&:hover': {
										  
										  backgroundColor: 'action.hover', 
										},
										
									  }}
									>
									  <Box
										component="img"
										src="/assets/Help.svg" 
										alt="" 
										sx={{
										  width: 40,  
										  height: 40,
										  display: 'block', 
										}}
									  />
									</IconButton>


                          </Box>
						</Box>
						<Divider sx={{ marginY: 1 }} />
						<Box sx={{ display: "flex", alignItems: "center", ml: 1 }}>
							<Autocomplete
								multiple
								options={searchOptions}
								filterSelectedOptions
								getOptionLabel={(option) => option.dropdownLabel}
								defaultValue={[]}
								groupBy={(option) => option.groupBy}
								renderTags={(tagValue, getTagProps) => {
									return tagValue.map((option, index) => (
										<Chip {...getTagProps({ index })} size="small" label={option.chipLabel} />
									));
								}}
								onChange={(e, newVal, reason) => {
									setSearchQuery(newVal);
								}}
								renderInput={(params) => (
									<TextField
										{...params}
										variant="filled"
										placeholder="Search by application name, environment, owner etc"
										fullWidth
										size="small"
										hiddenLabel
										InputProps={{
											...params.InputProps,
											startAdornment: (
												<>
													<InputAdornment position="start">
														<img
															src="/assets/search-normal.svg"
															alt="Filter Icon"
															style={{ width: "16px", paddingLeft: "4px" }}
														/>
													</InputAdornment>
													{params.InputProps.startAdornment}
												</>
											),
											disableUnderline: true,
											style: {
												backgroundColor: "#f4f4f4",
												minHeight: "45px",
												width: "500px",
												borderRadius: "8px",
												fontFamily: "Gilroy-Regular",
												fontSize: "14px",
											},
										}}
									/>
								)}
							/>

							<Button
								sx={{
									marginLeft: "16px",
									border: "1px solid #bbb",
									borderRadius: "10px",
									height: "45px",
									width: "45px",
								}}
								onClick={handleFilterClick}
							>
								<img src="/assets/pause.svg" alt="Filter Icon" style={{ width: "16px" }} />
							</Button>
							<Menu
								anchorEl={anchorEl}
								open={Boolean(anchorEl)}
								onClose={handleFilterClose}
								anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
							>
								<Box sx={{ padding: "8px" }}>
									<Typography sx={{ fontWeight: "bold", marginBottom: "8px" }}>
										TABLE COLUMNS
									</Typography>
									<FormGroup>
										{Object.keys(columnFilters).map((column) => (
											<FormControlLabel
												key={column}
												control={
													<Checkbox
														checked={columnFilters[column as keyof typeof columnFilters]}
														onChange={() => toggleColumnFilter(column)}
														sx={{
															color: "#000", // Black color for the checkbox
															"&.Mui-checked": {
																color: "#000", // Black color when checked
															},
															"& .MuiSvgIcon-root": {
																borderRadius: "50%", // Rounded shape for the checkbox icon
															},
														}}
													/>
												}
												label={
													column.charAt(0).toUpperCase() +
													column
														.slice(1)
														.replace(/([A-Z])/g, " $1")
														.trim()
												}
											/>
										))}
									</FormGroup>
									<Button
										variant="contained"
										onClick={handleFilterClose}
										sx={{
											marginTop: "8px",
											backgroundColor: "black",
											color: "white",
											width: "100%",
										}}
									>
										Apply
									</Button>
								</Box>
							</Menu>
						</Box>
					</Box>
					<Box m={2}>
						{filteredPendingApplications.length > 0 && (
							<Accordion
								defaultExpanded={filteredPendingApplications.length > 0 ? true : false}
								elevation={0}
								sx={{
									borderRadius: "8px",
									mb: "16px",
									"&:before": {
										display: "none",
									},
									bgcolor: "#fafafa",
								}}
								disabled={filteredPendingApplications.length == 0}
							>
								<AccordionSummary expandIcon={<ExpandMore />}>
									<Box sx={{ display: "flex", alignItems: "center" }}>
										<img
											src="/assets/clock.svg"
											alt="Pending Icon"
											style={{ width: "20px", marginRight: "8px" }}
										/>
										<Typography fontSize="16px" fontFamily="Gilroy-SemiBold">
											Pending Applications ({filteredPendingApplications.length})
										</Typography>
									</Box>
								</AccordionSummary>
								<AccordionDetails>
									{filteredPendingApplications.length > 0 && (
										<ApplicationsTable
											applications={filteredPendingApplications}
											columnFilters={columnFilters}
											type="pending"
											resourceStatuses={updates}
										/>
									)}
								</AccordionDetails>
							</Accordion>
						)}
						{filteredActiveApplications.length > 0 && (
							<Accordion
							defaultExpanded={true}
								elevation={0}
								sx={{
									borderRadius: "8px",
									mb: "16px",
									"&:before": {
										display: "none",
									},
									bgcolor: "#fafafa",
								}}
								disabled={filteredActiveApplications.length == 0}
							>
								<AccordionSummary expandIcon={<ExpandMore />}>
									<Box sx={{ display: "flex", alignItems: "center" }}>
										<img
											src="/assets/tickcircle.svg"
											alt="Active Icon"
											style={{ width: "20px", marginRight: "8px" }}
										/>
										<Typography fontSize="16px" fontFamily="Gilroy-SemiBold">
											Active Applications ({filteredActiveApplications.length})
										</Typography>
									</Box>
								</AccordionSummary>
								<AccordionDetails>
									{filteredActiveApplications.length > 0 && (
										<ApplicationsTable
											applications={filteredActiveApplications}
											columnFilters={columnFilters}
											type="active"
											resourceStatuses={updates}
										/>
									)}
								</AccordionDetails>
							</Accordion>
						)}

						{filteredRejectedApplications.length > 0 && (
							<Accordion
								elevation={0}
								sx={{
									borderRadius: "8px",
									"&:before": {
										display: "none",
									},
									bgcolor: "#fafafa",
								}}
								disabled={filteredRejectedApplications.length == 0}
							>
								<AccordionSummary expandIcon={<ExpandMore />}>
									<Box sx={{ display: "flex", alignItems: "center" }}>
										<img
											src="/assets/reject.svg"
											alt="Rejected Icon"
											style={{ width: "20px", marginRight: "8px" }}
										/>
										<Typography fontSize="16px" fontFamily="Gilroy-SemiBold">
											Rejected Applications ({filteredRejectedApplications.length})
										</Typography>
									</Box>
								</AccordionSummary>
								<AccordionDetails>
									{filteredRejectedApplications.length > 0 && (
										<ApplicationsTable
											applications={filteredRejectedApplications}
											columnFilters={columnFilters}
											type="rejected"
											resourceStatuses={updates}
										/>
									)}
								</AccordionDetails>
							</Accordion>
						)}
					</Box>
				</Container>
			</Box>
		</Box>
	);
};

export default ApplicationsPage;
